import React, { useState, useEffect } from 'react';

import { Container, Row, Col, Form, FormGroup, Input, Label, Button, TabContent, TabPane, Card, CardBody, Media, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import { createClient } from "@supabase/supabase-js";
import { Facebook } from 'react-feather'
import { toast } from 'react-toastify';
import { ReactBingmaps } from "react-bingmaps";
import "./styles.css"
import { Icon } from '@iconify/react';
import { Geolocation } from '@capacitor/geolocation';
import 'react-toastify/dist/ReactToastify.css';


toast.configure();




const SignIn = (props) => {

  console.warn = () => { }
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [mobilenumber, setmobilenumber] = useState('')
  const [address, setAddress] = useState('')
  const [gstnumber, setgstnumber] = useState('')
  const [tinno, settinno] = useState('')
  const [aadharno, setaadharno] = useState('')
  const [dob, setdob] = useState('')
  const [vehicletype, setvehicletype] = useState('')
  const [vehiclenumber, setvehiclenumber] = useState('')
  const [vehiclebodyweight, setvehiclebodyweight] = useState("")
  const [vehicletonnage, setvehicletonnage] = useState("")
  const [buyertype, setbuyertype] = useState("")
  const [suppliertype, setsuppliertype] = useState("Manufacturer")
  const [licensetype, setlicensetype] = useState("")
  const [licenseno, setlicenseno] = useState("")
  const [customer_type, setcustomer_type] = useState([])
  const [supplier_type, setsupplier_type] = useState([])
  const [license_type, setlicense_type] = useState([])
  const [vehicle_type, setvehicle_type] = useState([])
  const [supplier_coordinate, setsupplier_coordinate] = useState("")
  const [pushpinarr, setPushpinarr] = useState([{
    "latitude": 28.750591076255212,
    "longitude": 77.20027622752754,
    "title": "Supplier",
    "description": "Supplier",
  }]);


  const [loading, setLoading] = useState(false)
  const [loggedIn, setLoggedIn] = useState(false)
  const [mobile, setmobile] = useState("")
  const [password, setPassword] = useState("")
  const [verifyotp, setverifyotp] = useState(true)
  const [timer, settimer] = useState(0)
  const [currentwidth, setcurrentwidth] = useState(window.innerWidth)
  const [usertype, setusertype] = useState("")
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  const [selectedindex, setselectedindex] = useState(0)
  const [arr, setarr] = useState([
    { iconurl: "emojione-monotone:articulated-lorry", name: "Vehicle Owner" },
    { iconurl: "healthicons:truck-driver", name: "Driver" },
    { iconurl: "fa6-solid:building-user", name: "Buyer" },
    { iconurl: "fa6-solid:trowel-bricks", name: "Supplier" }])
  async function signInWithGoogle() {
    setLoading(true)
    const { user, session, error } = await supabase.auth.signIn({
      provider: 'google',
    })

    window.localStorage.setItem("LoggedInType", "Google")
    window.localStorage.setItem('activetab', 1)

  }
  const handleChange = (e) => {
    if (e.target.value.length < 6) {
      setPassword(e.target.value)
    } else {
      setPassword(e.target.value.slice(0, 6))
    }

  }
  const handlemobile = (e) => {
    if (e.target.value.length < 10) {
      setmobile(e.target.value)
    } else {
      setmobile(e.target.value.slice(0, 10))
    }
  }
  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  const validatevehicleno = (vehicleno) => {
    // var vehreg = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/
    if (vehicleno.length == 10 || vehicleno.length == 9) {
      return true
    } else {
      return false
    }
  }
  const validatelicenseno = (licenseno) => {
    var regex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;
    if (regex.test(licenseno)) {
      return true;
    } else {
      return false;
    }
  }
  const validateaadharno = (aadharno) => {
    var reg = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
    if (reg.test(aadharno)) {
      return true;
    } else {
      return false;
    }

  }
  const validategst = (gst) => {
    var gstreg = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/
    if (gstreg.test(gst)) {
      return true;
    } else {
      return false;
    }
  }

  const validateemail = (email) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (re.test(email)) {
      return true
    } else {
      return false
    }
  }
  function AddPushPinOnClick(e) {



    var arr = [];



    arr.push({
      "latitude": e.latitude,
      "longitude": e.longitude,
      "type": "Supplier",
      "title": "Supplier",
      "description": "Supplier Location",
    })
    setsupplier_coordinate(e.longitude + "," + e.latitude)

    setPushpinarr(arr);








  }

  const RegisterUser = async () => {
    if (usertype === "Vehicle Owner") {
      if (name === "") {
        toast.error("Please Enter Name")
      } else if (email === "") {
        toast.error("Please Enter Email")
      } else if (!validateemail(email)) {
        toast.error("Please Enter Valid Email")
      } else if (mobilenumber === "") {
        toast.error("Please Enter Mobile Number")
      } else if (mobilenumber.length !== 10) {
        toast.error("Please Enter Valid Mobile Number")
      } else if (vehiclenumber === "") {
        toast.error("Please Enter Vehicle Number")
      } else if (!validatevehicleno(vehiclenumber)) {
        toast.error("Please Enter Valid Vehicle Number")
      } else if (vehicletype === "") {
        toast.error("Please Select Vehicle Type")
      } else if (vehiclebodyweight === "") {
        toast.error("Please Enter Vehicle Body Weight")
      } else if (vehicletonnage === "") {
        toast.error("Please Enter Vehicle Tonnage")
      } else if (aadharno === "") {
        toast.error("Please Enter Aadhar Number")
      } else if (!validateaadharno(aadharno)) {
        toast.error("Please Enter Valid Aadhar Number")
      } else if (dob === "") {
        toast.error("Please Enter Date of Birth")
      } else {
        var vehicle_id = `owner${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: vehicle_id, user_name: name, user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_type: usertype, user_phone: parseInt("91" + mobilenumber), user_email: email, user_aadhar_no: parseInt(aadharno), user_dob: dob },
          ])

        if (user !== null) {
          const { data, error } = await supabase
            .from('vehicle_details')
            .insert([
              { vehicle_id: vehicle_id, vehicle_owner_email: email, vehicle_owner_name: name, vehicle_owner_number: parseInt("91" + mobilenumber), vehicle_owner_dob: dob, vehicle_owner_aadharno: parseInt(aadharno), vehicle_number: vehiclenumber, vehicle_type: vehicletype, vehicle_tonnage: parseInt(vehicletonnage), vehicle_bodyweight: parseInt(vehiclebodyweight) },
            ])
          if (data !== null) {

            window.localStorage.setItem("LoggedIn", false)
            window.localStorage.setItem('currentUser', user)
            toast.success(`${usertype} Registered Successfully`)
            initializeUser()

          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      }


    } else if (usertype === "Driver") {
      if (name == "") {
        toast.error("Please Enter Driver Name")
      } else if (mobilenumber == "") {
        toast.error("Please Enter Driver Mobile Number")
      } else if (mobilenumber.length != 10) {
        toast.error("Please Enter Valid Mobile Number")


      } else if (email == "") {
        toast.error("Please Enter Driver Email")
      } else if (!validateemail(email)) {
        toast.error("Please Enter Valid Email")

      } else if (licensetype == "") {
        toast.error("Please Select Driver License Type")
      } else if (licenseno == "") {
        toast.error("Please Enter Driver License Number")
      } else if (!validatelicenseno(licenseno)) {
        toast.error("Please Enter Valid Driver License Number")
      } else if (aadharno == "") {
        toast.error("Please Enter Driver Aadhar Number")
      } else if (!validateaadharno(aadharno)) {
        toast.error("Please Enter Valid Driver Aadhar Number")
      } else if (dob == "") {
        toast.error("Please Enter Driver Date of Birth")
      } else {
        var driver_id = `driver${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: driver_id, user_name: name, user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_type: usertype, user_phone: parseInt("91" + mobilenumber), user_email: email, user_aadhar_no: parseInt(aadharno), user_dob: dob },
          ])

        if (user !== null) {
          const { data, error } = await supabase
            .from('driver_details')
            .insert([
              { driver_id: driver_id, driver_email: email, driver_name: name, driver_phone: parseInt("91" + mobilenumber), driver_dob: dob, driver_aadhar_no: parseInt(aadharno), driver_dob: dob, driver_licensetype: licensetype, driver_licence: licenseno },
            ])

          if (data !== null) {

            window.localStorage.setItem("LoggedIn", false)
            window.localStorage.setItem('currentUser', user)
            toast.success(`${usertype} Registered Successfully`)
            initializeUser()

          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      }


    } else if (usertype === "Buyer") {
      if (name === "") {
        toast.error("Please Enter Name")
      } else if (mobilenumber === "") {
        toast.error("Please Enter Mobile Number")
      } else if (mobilenumber.length < 10) {
        toast.error("Please Enter Valid Mobile Number")
      } else if (email === "") {
        toast.error("Please Enter Email")
      } else if (!validateemail(email)) {
        toast.error("Please Enter Valid Email")
      } else if (buyertype === "") {
        toast.error("Please Select Buyer Type")
      } else if (vehicletype === "") {
        toast.error("Please Select Vehicle Type")
      } else if (vehiclenumber === "") {
        toast.error("Please Enter Vehicle Number")
      } else if (!validatevehicleno(vehiclenumber)) {
        toast.error("Please Enter Valid Vehicle Number")
      } else if (gstnumber === "" && (aadharno === "" || dob === "" || !validateaadharno(aadharno))) {
        if (gstnumber === "" && aadharno === "" && dob === "" && !validateaadharno(aadharno)) {
          toast.error("Please Enter GST Number")

        } else {
          if (aadharno === "") {
            toast.error("Please Enter Aadhar Number")
          } else if (!validateaadharno(aadharno)) {
            toast.error("Please Enter Valid Aadhar Number")
          }
          else if (dob === "") {
            toast.error("Please Enter Date of Birth")
          }
        }




      } else if (gstnumber !== "" && (aadharno === "" || dob === "") && !validategst(gstnumber)) {
        toast.error("Please Enter Valid GST Number")
      } else if (address === "") {
        toast.error("Please Enter Address")
      } else {
        var customer_id = `buyer${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: customer_id, user_name: name, user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_type: usertype, user_phone: parseInt("91" + mobilenumber), user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          ])
        console.log(user, error1)
        if (user !== null) {
          const { data, error } = await supabase
            .from('Buyer_details')
            .insert([
              { customer_id: customer_id, customer_email: email, customer_name: name, customer_address: address, customer_phone: parseInt("91" + mobilenumber), customer_dob: dob, customer_aadhar_no: parseInt(aadharno), customer_vehiclenumber: vehiclenumber, customer_vehicletype: vehicletype, customer_type: buyertype, customer_gstnumber: gstnumber },
            ])
          console.log(data, error)
          if (data !== null) {

            window.localStorage.setItem("LoggedIn", false)
            window.localStorage.setItem('currentUser', user)
            toast.success(`${usertype} Registered Successfully`)
            initializeUser()

          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      }

    } else {
      if (name === "") {
        toast.error("Please Enter Name")
      } else if (mobilenumber === "") {
        toast.error("Please Enter Mobile Number")
      } else if (mobilenumber.length < 10) {
        toast.error("Please Enter Valid Mobile Number")
      } else if (email === "") {
        toast.error("Please Enter Email")
      } else if (!validateemail(email)) {
        toast.error("Please Enter Valid Email")
      } else if (vehicletype === "") {
        toast.error("Please Select Vehicle Type")
      } else if (supplier_type === "") {
        toast.error("Please Select Supplier Type")
      } else if (gstnumber === "") {
        toast.error("Please Enter GST Number")
      } else if (!validategst(gstnumber)) {
        toast.error("Please Enter Valid GST Number")
      } else if (address === "") {
        toast.error("Please Enter Address")
      } else if (tinno === "") {
        toast.error("Please Enter TIN Number")

      } else if (supplier_coordinate === "") {
        
        toast.error("Please Choose Location on Map")
      } else {
        var man_id = `supplier${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: man_id, user_name: name, user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_type: usertype, user_phone: parseInt("91" + mobilenumber), user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          ])
        console.log(user, error1)
        if (user !== null) {
          const { data, error } = await supabase
            .from('supplier_details')
            .insert([
              { man_id: man_id, man_email: email,supplier_coordinate:supplier_coordinate, man_name: name, man_address: address, man_phone: parseInt("91" + mobilenumber), man_vehicletype: vehicletype, man_type: suppliertype, man_gstnumber: gstnumber, man_tin: tinno },
            ])
          console.log(data, error)
          if (data !== null) {

            window.localStorage.setItem("LoggedIn", false)
            window.localStorage.setItem('currentUser', user)
            toast.success(`${usertype} Registered Successfully`)
            initializeUser()

          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      }


    }
  }

  const UpdateUserType = (index) => {
    setname("")
    if (window.localStorage.getItem("LoggedInType") === "Google") {
      setmobilenumber("")
    } else {
      setemail("")
    }


    setAddress("")
    setgstnumber("")
    settinno("")
    setaadharno("")
    setdob("")
    setvehicletype("")
    setvehiclenumber("")
    setvehiclebodyweight("")
    setvehicletonnage("")
    setbuyertype("")
    setsuppliertype("Manufacturer")
    setlicensetype("")
    setlicenseno("")

    if (index === 0) {
      setusertype("Vehicle Owner")
    } else if (index === 1) {
      setusertype("Driver")
    } else if (index === 2) {
      setusertype("Buyer")
    } else {
      setusertype("Supplier")
    }
  }

  async function SignInWithMobile() {

    if (mobile === "") {

      setTimeout(() => {

        toast.error("Please Enter Mobile Number")

      }, 300)

    } else {
      if (mobile.length < 10) {
        toast.error("Please Enter Valid Mobile No")
        return
      } else {
        setLoading(true)


        let { user, error } = await supabase.auth.signUp({
          phone: `+91${mobile}`,
          password: '123456',
        })
        if (user != null) {
          let { user1, error1 } = await supabase.auth.signIn({
            phone: `+91${mobile}`,
          })
          settimer(59)

          setverifyotp(false)
          setLoading(false)
        } else {
          if (user === null && error.message === "User already registered") {
            let { user1, error1 } = await supabase.auth.signIn({
              phone: `+91${mobile}`,
            })

            settimer(59)
            setverifyotp(false)
            setLoading(false)
          }
          setLoading(false)
        }

      }
    }

  }
  async function ResendOtp() {



    if (mobile === "") {
      toast.error("Please Enter Mobile Number")
      return
    } else {
      if (mobile.length < 10) {
        toast.error("Please Enter Valid Mobile No")
        return
      } else {
        let { user1, error1 } = await supabase.auth.signIn({
          phone: `+91${mobile}`,
        })


        settimer(59)

        setLoading(false)
      }
    }

  }
  useEffect(() => {

    const counter =
      timer > 0 && setInterval(() => settimer(timer - 1), 1000);
    return () => clearInterval(counter);
  }, [timer]);
  async function verifyOtp() {
    window.localStorage.setItem('activetab', 1)
    if (mobile === "") {
      toast.error("Please Enter Mobile Number")
      return
    } else {
      if (mobile.length < 10) {
        toast.error("Please Enter Valid Mobile No")
        return
      } else {
        if (password === "") {
          toast.error("Please Enter OTP")
          return
        } else {
          if (password.length < 6) {
            toast.error("Please Enter Valid OTP")
            return
          } else {

            let { session, error } = await supabase.auth.verifyOTP({
              phone: `+91${mobile}`,
              token: password,
            })

            if (error === null) {
              if (session != null) {
                const user = supabase.auth.user();
                if (user !== null) {
                  window.localStorage.setItem("LoggedInType", "Mobile")
                  window.localStorage.setItem("LoggedIn", false)

                  window.localStorage.setItem('currentUser', user)
                  initializeUser()
                } else {
                  window.localStorage.setItem("LoggedInType", "Mobile")

                  window.localStorage.setItem("LoggedIn", true)
                  initializeUser()
                  setLoggedIn(window.localStorage.getItem("LoggedIn"))
                  settimer(0)
                  setverifyotp(false)
                  setLoading(false)
                  setPassword("")
                  setmobile("")
                }

                // window.localStorage.setItem("currentUser", mobile);
                // window.location.href = "/Home";
              } else {

                window.localStorage.setItem("currentUser", "null");
                window.location.href = "/";
                setverifyotp(true)
                setLoading(false)
                setPassword("")
                setmobile("")
              }
            } else {
              toast.error("Please Enter Valid OTP")
            }
            setLoading(false)
          }
        }
      }
    }
  }

  const initializeUser = async () => {
    const user = supabase.auth.user();


    if (user !== null) {
      window.localStorage.setItem('activetab', 1)
      if (window.localStorage.getItem("LoggedInType") === "Mobile") {
        let { data: User_Details, error } = await supabase
          .from('User_Details')
          .select("*")
          .eq('user_phone', user.phone)

        if (User_Details !== null && User_Details.length > 0) {

          window.localStorage.setItem('currentUser', User_Details)
          window.location.href = "/Home";
          window.localStorage.setItem("LoggedIn", false)

        } else {

          window.localStorage.setItem('currentUser', null)
          window.localStorage.setItem("LoggedIn", true)
          setLoggedIn("true")
          setmobilenumber(user.phone.toString().slice(2, 12))
        }

      } else {
        let { data: User_Details, error } = await supabase
          .from('User_Details')
          .select("*")
          .eq('user_email', user.email)


        if (User_Details !== null && User_Details.length > 0) {

          window.localStorage.setItem('currentUser', User_Details)
          window.localStorage.setItem("LoggedIn", false)
          window.location.href = "/Home";

        } else {

          window.localStorage.setItem('currentUser', null)
          window.localStorage.setItem("LoggedIn", true)
          setLoggedIn("true")
          setemail(user.email)
        }

      }






    } else {
      window.localStorage.setItem("currentUser", "null");
      window.localStorage.setItem("LoggedIn", false)
      setLoggedIn("false")
      window.location.href = "/";
    }

  };

  async function getcoordinate(){
    await Geolocation.getCurrentPosition().then((position) => {
      
      setPushpinarr([{
        "latitude": position.coords.latitude,
        "longitude": position.coords.longitude,
        "title": "Supplier",
        "description": "Supplier",
      }])
    })
  }
  useEffect(()=>{
    getcoordinate()
  },[])


  useEffect(async () => {
    setcurrentwidth(window.innerWidth)
    let { data: customer_type, error } = await supabase
      .from('customer_type_details')
      .select('*')

    if (error === null) {

      setcustomer_type(customer_type)
    }

    let { data: supplier_type, error1 } = await supabase
      .from('supplier_type_details')
      .select('*')
    if (error1 === undefined) {
      setsupplier_type(supplier_type)
    }

    let { data: driver_license_type, error2 } = await supabase
      .from('driver_license_type')
      .select('*')

    if (error2 === undefined) {
      setlicense_type(driver_license_type)

    }

    let { data: vehicle_type, error3 } = await supabase
      .from('vehicle_type_details')
      .select('*')
    if (error3 === undefined) {
      setvehicle_type(vehicle_type)
    }

    const user = supabase.auth.user();
    console.log(user)

    if (user !== null) {
      initializeUser()

    } else {
      setLoggedIn("false")
    }
    supabase.auth.onAuthStateChange((event, session) => {

      if (event === "SIGNED_IN") initializeUser()

    });
    return () => {
      supabase.removeSubscription();

    };
  }, []);













  return (
    <Container fluid={true}>
      <Row>
        <Col xl="7" className="b-center bg-size" style={currentwidth < 800 ? { backgroundColor: "white", backgroundSize: "cover", backgroundPosition: "center", display: "block" } : { background: `url(${require("../assets/images/login/2.jpg")})`, backgroundSize: "cover", backgroundPosition: "center", display: "block" }}>

          <img className="bg-img-cover bg-center" style={{ display: "none" }} src={require("../assets/images/login/2.jpg")} alt="looginpage" />
        </Col>
        <Col xl="5" className="p-0">

          <div className="login-card"  >
            <div style={currentwidth < 800 ? { textAlign: "center" } : { width: "100%" }}>
              <div>
                <span className={currentwidth < 800 ? "logo" : "logo "} style={{ cursor: "pointer" }} onClick={() => {
                  setusertype(""); setselectedindex(0)
                }}>
                  <img className="img-fluid for-light" src={require("../assets/images/logo/logo.png")} alt="looginpage" style={{ width: "200px" }} />
                  {/* <img className="img-fluid for-dark" src={require("../assets/images/logo/logo_dark.png")} alt="looginpage" /> */}
                </span>
              </div>

              {currentwidth < 800 ?
                <div className="login-main login-tab" style={currentwidth < 800 ? { boxShadow: "rgba(0, 0, 0, 0.20) 0px 10px 60px", marginTop: '0px' } : { marginTop: '0px' }} >

                  <TabContent activeTab={"firebase"} className="content-login" style={{ height: "auto" }}>
                    {loggedIn === "true" ? <TabPane className="fade show" tabId="firebase" >
                      {usertype === "" ? <Form className="theme-form">
                        <h4 style={{ textAlign: "center" }}><b>Select User</b></h4>
                        <br />
                        <Row>
                          {arr.map((data, i) => {
                            return (

                              <Col sm="6" key={i}>
                                {selectedindex === i ? <Card style={{ backgroundColor: "#211833", margin: "12px " }}>

                                  <CardBody style={{ padding: "10px", cursor: "pointer" }} onClick={() => {
                                    getcoordinate()
                                    setselectedindex(i)
                                  }}>
                                    <Media style={{ justifyContent: "center" }}>


                                      <Icon icon={data.iconurl} color="white" width="45" height="45" />



                                    </Media>
                                    <div className="mt-2" style={{ textAlign: "center", color: "white" }}> <span >{data.name}</span></div>
                                  </CardBody>

                                </Card> : <Card style={{ margin: "12px ", cursor: "pointer" }} onClick={() => {
                                  getcoordinate()
                                  setselectedindex(i)
                                }}>

                                  <CardBody style={{ padding: "10px" }}>
                                    <Media style={{ justifyContent: "center" }}>


                                      <Icon icon={data.iconurl} color="black" width="45" height="45" />



                                    </Media>
                                    <div className="mt-2" style={{ textAlign: "center", color: "black" }}> <span >{data.name}</span></div>
                                  </CardBody>

                                </Card>}

                              </Col>)
                          })}


                        </Row>




                        <FormGroup className="mb-0 mt-3">


                          <Button color="primary" className="btn-block" onClick={() => {
                            UpdateUserType(selectedindex)
                          }}>PROCEED </Button>
                        </FormGroup>


                      </Form> :
                        <>
                          <Col sm="2">
                            <button type='button' className="btn btn-primary btn-block" onClick={() => { setusertype(""); setselectedindex(0) }}>Back</button>
                          </Col>
                          <Col sm="12">
                            <h5 style={{ textAlign: "center" }}><b>Register here for {usertype}</b></h5>
                          </Col>
                          <br />
                          <div style={usertype === "Driver" ? { height: "auto" } : { height: "auto", maxHeight: "600px", overflowX: "hidden", overflowY: "scroll" }}>
                            {usertype === "Driver" ?
                              <Row>
                                <Col>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">License Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">

                                      <Input className="form-control" type="select" placeholder="Choose Your License Type" value={licensetype} onChange={(e) => { setlicensetype(e.target.value) }}>
                                        <option value={""}>Choose Your License Type</option>
                                        {license_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.license_type}>{data.license_type}</option>
                                          )
                                        })}
                                      </Input>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">License No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your License No" value={licenseno} onChange={(e) => { setlicenseno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                    </Col>
                                  </FormGroup>





                                </Col>
                              </Row> : ""}
                            {usertype === "Vehicle Owner" ? <Row>
                              <Col>

                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                  </Col>
                                </FormGroup>

                                <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                      <option value={""}>Choose Your Vehicle Type</option>
                                      {vehicle_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                        )
                                      })}
                                    </Input>

                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                      setvehiclenumber(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Vehicle Tonnage" value={vehicletonnage} onChange={(e) => {
                                      setvehicletonnage(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle BodyWeight<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="number" placeholder="Enter Vehicle BodyWeight" value={vehiclebodyweight} onChange={(e) => {
                                      setvehiclebodyweight(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>





                              </Col>
                            </Row> : ""}
                            {usertype === "Buyer" ?
                              <Row>
                                <Col>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <hr></hr>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Aadhar No</Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Date Of Birth</Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Buyer Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">

                                      <Input className="form-control" type="select" value={buyertype} onChange={(e) => {
                                        setbuyertype(e.target.value)
                                      }}>
                                        <option value={""}>Choose Your Buyer Type</option>
                                        {customer_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.customer_type}>{data.customer_type}</option>
                                          )
                                        })}
                                      </Input>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                        <option value={""}>Choose Your Vehicle Type</option>
                                        {vehicle_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                          )
                                        })}
                                      </Input>

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                        setvehiclenumber(e.target.value)
                                      }} />
                                    </Col>
                                  </FormGroup>






                                </Col>
                              </Row> : ""}
                            {usertype === "Supplier" ? <Row>
                              <Col>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Supplier Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={suppliertype} onChange={(e) => {
                                      setsuppliertype(e.target.value)
                                    }}>
                                      <option value={""}>Choose Your Supplier Type</option>
                                      {supplier_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.supplier_type}>{data.supplier_type}</option>
                                        )
                                      })}
                                    </Input>

                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  {suppliertype === "Supplier" ? <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label> : <Label className="col-sm-12 col-form-label">Company Name<span style={{ color: "#E50014" }}>*</span></Label>}

                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>


                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Tin No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Tin No" value={tinno} onChange={(e) => {
                                      settinno(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                      <option value={""}>Choose Your Vehicle Type</option>
                                      {vehicle_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                        )
                                      })}
                                    </Input>
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Location <span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <div className='map-four' >
                                      <ReactBingmaps

                                        center={[28.750591076255212, 77.20027622752754]}
                                        zoom={7}
                                        className="customClass"
                                        bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                                        getLocation={
                                          { addHandler: "click", callback: AddPushPinOnClick }
                                        }
                                        infoboxesWithPushPins={
                                          pushpinarr.length > 0 && pushpinarr.map((item) => {
                                            return (
                                              {


                                                location: [item.latitude, item.longitude],

                                                addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                                                infoboxOption: { title: item.title, description: item.description },
                                                pushPinOption: { title: item.title, description: item.description },

                                              }
                                            );
                                          })


                                        }


                                      />
                                    </div>
                                  </Col>
                                </FormGroup>






                              </Col>
                            </Row> : ""}






                            <FormGroup className="mb-0 mt-3">


                              <Button color="primary" className="btn-block" onClick={() => {
                                RegisterUser()
                              }}>PROCEED </Button>
                            </FormGroup>
                          </div>


                        </>}
                    </TabPane> : <TabPane className="fade show" tabId="firebase" >
                      <Form className="theme-form">
                        <h4 style={{ color: "#E50014" }}>Welcome User!</h4>
                        <hr style={{ marginTop: "1rem", marginBottom: "1rem", border: "0", borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />


                        {verifyotp ? <h5>{"Login with Mobile No "}</h5> : <h6>{"Verify Your OTP "}</h6>}
                        <FormGroup>
                          <Label className="col-form-label" style={currentwidth < 800 ? { float: "left" } : { float: "left" }}>Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                          <Input className="form-control" type="number" value={mobile} style={currentwidth < 800 ? { height: "50px", borderRadius: "10px", fontSize: "18px" } : { height: "auto" }} onChange={(e) => {
                            handlemobile(e)

                          }} placeholder="Enter Mobile No" />
                        </FormGroup>
                        {verifyotp ? "" : <FormGroup>
                          <Label className="col-form-label" style={currentwidth < 800 ? { float: "left" } : { float: "left" }}>OTP<span style={{ color: "#E50014" }}>*</span></Label>
                          <Input className="form-control" type="number" style={currentwidth < 800 ? { height: "50px", borderRadius: "10px", fontSize: "18px" } : { height: "auto" }} value={password} onChange={(e) => handleChange(e)} placeholder="*********" />
                          {/* <div className="show-hide" onClick={() => HideShowPassword(togglePassword)}><span className={togglePassword ? "" : "show"}></span></div> */}
                        </FormGroup>}
                        <FormGroup className="mb-0 mt-3">


                          {verifyotp ? <Button color="primary" style={currentwidth < 800 ? { height: "45px" } : { height: "auto" }} className="btn-block" disabled={loading} onClick={() => {
                            SignInWithMobile()
                          }}>Sign In</Button> : <Button color="primary" style={currentwidth < 800 ? { height: "45px" } : { height: "auto" }} className="btn-block" onClick={() => {
                            verifyOtp()
                          }}>Verify </Button>}
                          {verifyotp ? "" : <> {timer > 0 ? <p className="mt-4 mb-0" style={{ float: "right" }} disabled>Resend OTP in 00:{timer.toString().length > 1 ? timer : `0${timer}`}</p> : <p className="mt-4 mb-0" style={{ float: "right" }} onClick={() => {
                            ResendOtp()
                          }}><a className="ml-2" href="#javascript" >Resend </a></p>}</>}
                          <br />
                        </FormGroup>
                        <h6 className="text-muted mt-4">{"Or Sign in with"}</h6>
                        <div className="social mt-4">
                          <div className="btn-showcase">
                            <Button color="light">
                              <Facebook className="txt-fb" />
                            </Button>
                            <Button color="light" onClick={() => { signInWithGoogle() }}>
                              <i className="fa fa-google"></i>
                            </Button>

                          </div>
                        </div>
                        {/* <p className="mt-4 mb-0">{"Don't have account?"}<a className="ml-2" href="#javascript">{CreateAccount}</a></p> */}
                      </Form>
                    </TabPane>}

                  </TabContent>
                </div>
                :
                <div className="login-main login-tab" style={usertype === "" ? { width: "450px" } : { width: "720px" }}>

                  <TabContent activeTab={"firebase"} className="content-login" style={{ height: "auto" }}>
                    {loggedIn === "true" ? <TabPane className="fade show" tabId="firebase" >
                      {usertype === "" ? <Form className="theme-form">
                        <h4 style={{ textAlign: "center" }}><b>Select User</b></h4>
                        <br />
                        <Row>
                          {arr.map((data, i) => {
                            return (

                              <Col sm="6" key={i}>
                                {selectedindex === i ? <Card style={{ backgroundColor: "#211833", margin: "12px " }}>

                                  <CardBody style={{ padding: "10px", cursor: "pointer" }} onClick={() => {
                                    setselectedindex(i)
                                  }}>
                                    <Media style={{ justifyContent: "center" }}>


                                      <Icon icon={data.iconurl} color="white" width="45" height="45" />



                                    </Media>
                                    <div className="mt-2" style={{ textAlign: "center", color: "white" }}> <span >{data.name}</span></div>
                                  </CardBody>

                                </Card> : <Card style={{ margin: "12px ", cursor: "pointer" }} onClick={() => {
                                  setselectedindex(i)
                                }}>

                                  <CardBody style={{ padding: "10px" }}>
                                    <Media style={{ justifyContent: "center" }}>


                                      <Icon icon={data.iconurl} color="black" width="45" height="45" />



                                    </Media>
                                    <div className="mt-2" style={{ textAlign: "center", color: "black" }}> <span >{data.name}</span></div>
                                  </CardBody>

                                </Card>}

                              </Col>)
                          })}


                        </Row>




                        <FormGroup className="mb-0 mt-3">


                          <Button color="primary" className="btn-block" onClick={() => {
                            UpdateUserType(selectedindex)
                          }}>PROCEED </Button>
                        </FormGroup>


                      </Form> :
                        <>
                          <Col sm="2">
                            <button type='button' className="btn btn-primary btn-block" onClick={() => { setusertype(""); setselectedindex(0) }}>Back</button>
                          </Col>
                          <Col sm="12">
                            <h5 style={{ textAlign: "center" }}><b>Register here for {usertype}</b></h5>
                          </Col>
                          <br />
                          <div style={usertype === "Driver" ? { height: "auto" } : { height: "auto", maxHeight: "600px", overflowX: "hidden", overflowY: "scroll" }}>
                            {usertype === "Driver" ?
                              <Row>
                                <Col>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">License Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">

                                      <Input className="form-control" type="select" placeholder="Choose Your License Type" value={licensetype} onChange={(e) => { setlicensetype(e.target.value) }}>
                                        <option value={""}>Choose Your License Type</option>
                                        {license_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.license_type}>{data.license_type}</option>
                                          )
                                        })}
                                      </Input>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">License No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your License No" value={licenseno} onChange={(e) => { setlicenseno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                    </Col>
                                  </FormGroup>





                                </Col>
                              </Row> : ""}
                            {usertype === "Vehicle Owner" ? <Row>
                              <Col>

                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                  </Col>
                                </FormGroup>

                                <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                      <option value={""}>Choose Your Vehicle Type</option>
                                      {vehicle_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                        )
                                      })}
                                    </Input>

                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                      setvehiclenumber(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Vehicle Tonnage" value={vehicletonnage} onChange={(e) => {
                                      setvehicletonnage(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle BodyWeight<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="number" placeholder="Enter Vehicle BodyWeight" value={vehiclebodyweight} onChange={(e) => {
                                      setvehiclebodyweight(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>





                              </Col>
                            </Row> : ""}
                            {usertype === "Buyer" ?
                              <Row>
                                <Col>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <hr></hr>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Aadhar No</Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Date Of Birth</Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Buyer Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">

                                      <Input className="form-control" type="select" value={buyertype} onChange={(e) => {
                                        setbuyertype(e.target.value)
                                      }}>
                                        <option value={""}>Choose Your Buyer Type</option>
                                        {customer_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.customer_type}>{data.customer_type}</option>
                                          )
                                        })}
                                      </Input>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                        <option value={""}>Choose Your Vehicle Type</option>
                                        {vehicle_type.map((data, i) => {

                                          return (
                                            <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                          )
                                        })}
                                      </Input>

                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                                        setvehiclenumber(e.target.value)
                                      }} />
                                    </Col>
                                  </FormGroup>






                                </Col>
                              </Row> : ""}
                            {usertype === "Supplier" ? <Row>
                              <Col>

                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Supplier Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={suppliertype} onChange={(e) => {
                                      setsuppliertype(e.target.value)
                                    }}>
                                      <option value={""}>Choose Your Supplier Type</option>
                                      {supplier_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.supplier_type}>{data.supplier_type}</option>
                                        )
                                      })}
                                    </Input>

                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  {suppliertype === "Supplier" ? <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label> : <Label className="col-sm-12 col-form-label">Company Name<span style={{ color: "#E50014" }}>*</span></Label>}

                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                                        </InputGroupAddon>
                                        {window.localStorage.getItem("LoggedInType") === "Mobile" ? <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} readOnly/>:<Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />}
                                      </InputGroup>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup className="row">
                                    <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                                    <Col sm="12">
                                      {window.localStorage.getItem("LoggedInType") === "Google" ? <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} readOnly/> : <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }}  />}

                                    </Col>
                                  </FormGroup>


                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Tin No<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="text" placeholder="Enter Your Tin No" value={tinno} onChange={(e) => {
                                      settinno(e.target.value)
                                    }} />
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                                      <option value={""}>Choose Your Vehicle Type</option>
                                      {vehicle_type.map((data, i) => {

                                        return (
                                          <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                        )
                                      })}
                                    </Input>
                                  </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                  <Label className="col-sm-12 col-form-label">Location <span style={{ color: "#E50014" }}>*</span></Label>
                                  <Col sm="12">
                                    <div className='map-four' >
                                      <ReactBingmaps

                                        center={[28.750591076255212, 77.20027622752754]}
                                        zoom={7}
                                        className="customClass"
                                        bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                                        getLocation={
                                          { addHandler: "click", callback: AddPushPinOnClick }
                                        }
                                        infoboxesWithPushPins={
                                          pushpinarr.length > 0 && pushpinarr.map((item) => {
                                            return (
                                              {


                                                location: [item.latitude, item.longitude],
                                                addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                                                infoboxOption: { title: item.title, description: item.description },
                                                pushPinOption: { title: item.title, description: item.description },

                                              }
                                            );
                                          })


                                        }


                                      />
                                    </div>
                                  </Col>
                                </FormGroup>






                              </Col>
                            </Row> : ""}






                            <FormGroup className="mb-0 mt-3">


                              <Button color="primary" className="btn-block" onClick={() => {
                                RegisterUser()
                              }}>PROCEED </Button>
                            </FormGroup>
                          </div>


                        </>}
                    </TabPane> : <TabPane className="fade show" tabId="firebase" >
                      <Form className="theme-form">
                        <h4>Sign In With Mobile No</h4>
                        {verifyotp ? <p>{"Enter your Mobile No "}</p> : <p>{"Verify Your OTP "}</p>}
                        <FormGroup>
                          <Label className="col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                          <Input className="form-control" type="number" value={mobile} onChange={(e) => {
                            handlemobile(e)

                          }} placeholder="Enter Mobile No" />
                        </FormGroup>
                        {verifyotp ? "" : <FormGroup>
                          <Label className="col-form-label">OTP<span style={{ color: "#E50014" }}>*</span></Label>
                          <Input className="form-control" type="number" value={password} onChange={(e) => handleChange(e)} placeholder="*********" />
                          {/* <div className="show-hide" onClick={() => HideShowPassword(togglePassword)}><span className={togglePassword ? "" : "show"}></span></div> */}
                        </FormGroup>}
                        <FormGroup className="mb-0 mt-3">


                          {verifyotp ? <Button color="primary" className="btn-block" disabled={loading} onClick={() => {
                            SignInWithMobile()
                          }}>Sign In</Button> : <Button color="primary" className="btn-block" onClick={() => {
                            verifyOtp()
                          }}>Verify </Button>}
                          {verifyotp ? "" : <> {timer > 0 ? <p className="mt-4 mb-0" style={{ float: "right" }} disabled>Resend OTP in 00:{timer.toString().length > 1 ? timer : `0${timer}`}</p> : <p className="mt-4 mb-0" style={{ float: "right" }} onClick={() => {
                            ResendOtp()
                          }}><a className="ml-2" href="#javascript" >Resend </a></p>}</>}
                          <br />
                        </FormGroup>
                        <h6 className="text-muted mt-4 or">{"Or Sign in with"}</h6>
                        <div className="social mt-4">
                          <div className="btn-showcase">
                            <Button color="light">
                              <Facebook className="txt-fb" />
                            </Button>
                            <Button color="light" onClick={() => { signInWithGoogle() }}>
                              <i className="fa fa-google"></i>
                            </Button>

                          </div>
                        </div>
                        {/* <p className="mt-4 mb-0">{"Don't have account?"}<a className="ml-2" href="#javascript">{CreateAccount}</a></p> */}
                      </Form>
                    </TabPane>}

                  </TabContent>
                </div>}
            </div>
          </div>
        </Col>
      </Row>
    </Container>

  );
}

export default SignIn;